import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var SelectWrapper = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: ", ";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  color: ", ";\n  width: 100%;\n\n  .custom-dropdown-icon {\n    fill: ", ";\n\n    padding-right: 8px;\n  }\n\n  .react-select__control {\n    background-color: ", ";\n    min-height: ", ";\n    border-radius: ", ";\n    border-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.1px;\n    cursor: pointer;\n  }\n\n  [class$=\"-control\"]:hover {\n    border-color: ", ";\n  }\n\n  .react-select__control--is-focused {\n    outline: none;\n    border-color: ", ";\n    box-shadow: none;\n  }\n\n  .react-select__control--is-disabled {\n    background-color: transparent;\n    border-color: ", ";\n    color: ", ";\n\n    .react-select__placeholder {\n      color: ", ";\n    }\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n\n  .react-select__multi-value {\n    border-radius: ", ";\n    background-color: ", ";\n  }\n\n  .react-select__multi-value__label {\n    padding: ", ";\n  }\n\n  .react-select__multi-value__remove:hover {\n    background-color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  .react-select__menu-notice {\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.014px;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: ", ";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  color: ", ";\n  width: 100%;\n\n  .custom-dropdown-icon {\n    fill: ", ";\n\n    padding-right: 8px;\n  }\n\n  .react-select__control {\n    background-color: ", ";\n    min-height: ", ";\n    border-radius: ", ";\n    border-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.1px;\n    cursor: pointer;\n  }\n\n  [class$=\"-control\"]:hover {\n    border-color: ", ";\n  }\n\n  .react-select__control--is-focused {\n    outline: none;\n    border-color: ", ";\n    box-shadow: none;\n  }\n\n  .react-select__control--is-disabled {\n    background-color: transparent;\n    border-color: ", ";\n    color: ", ";\n\n    .react-select__placeholder {\n      color: ", ";\n    }\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n\n  .react-select__multi-value {\n    border-radius: ", ";\n    background-color: ", ";\n  }\n\n  .react-select__multi-value__label {\n    padding: ", ";\n  }\n\n  .react-select__multi-value__remove:hover {\n    background-color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  .react-select__menu-notice {\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.014px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.components.input.label.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? theme.colors.neutral.light : theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? theme.colors.neutral.light : theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.height[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.borderRadius[theme.device];
}, function (_a) {
    var theme = _a.theme, $hasError = _a.$hasError;
    return $hasError ? theme.colors.red.default : theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.lighter;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red.lightest;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map